import * as React from 'react';
import styled from 'styled-components';
import API from 'api';
import { useBreakpoint } from 'hooks';
import { AuthContextUser } from 'contexts/types';
import theme from '../../theme';
import { Divider } from '../../Divider';

import {
  FinancialDetails,
  IncludedAndExcludedList,
  ListingDetails,
  MoreInfoList,
  PropertyDetails,
  PropertyInfo,
  RequiredList,
  RoomDetails,
} from '../../../app/DashboardComponents/ListingViewComponents';

interface AboutProps {
  listing: any;
  attachments: any[];
  auth?: AuthContextUser;
}

const About: React.FC<AboutProps> = ({ listing, attachments, auth }) => {
  const [enableOpenHouses, setEnableOpenHouses] = React.useState(false);
  const { md } = useBreakpoint();

  React.useEffect(() => {
    (async () => {
      const fetchedOrgSettings = await API.GET.getOrgSettings();
      if (fetchedOrgSettings.enableOpenHouses) setEnableOpenHouses(true);
    })();
  }, []);

  return (
    <>
      <Divider />
      <StyledFlexDiv $md={md}>
        <StyledPropertyInfoWrapper>
          <PropertyInfo
            listing={listing}
            attachments={attachments}
            enableOpenHouses={enableOpenHouses}
          />
        </StyledPropertyInfoWrapper>
        <StyledDetailsWrapper $md={md}>
          <ListingDetails listing={listing} />
          <PropertyDetails listing={listing} />
        </StyledDetailsWrapper>
      </StyledFlexDiv>
      {listing.rooms.length > 0 && md && (
        <>
          <Divider />
          <RoomDetails
            country={auth?.org.country}
            rooms={listing.rooms}
            roomUnit={listing.roomUnit}
          />
        </>
      )}
      {listing.subtype === 'lease' && listing.freehold && (
        <>
          <Divider />
          <IncludedAndExcludedList freehold={listing.freehold} />
        </>
      )}
      {listing.type === 'commercial' && listing.more_info && (
        <>
          <Divider />
          <MoreInfoList moreInfo={listing.more_info} />
        </>
      )}
      {listing.type === 'commercial' && listing.financials && (
        <>
          <Divider />
          <FinancialDetails financials={listing.financials} />
        </>
      )}
      {listing.subtype === 'lease' &&
        (listing.type === 'freehold' || listing.type === 'condo') &&
        listing.required && (
          <>
            <Divider />
            <RequiredList requiredItems={listing.required} />
          </>
        )}
    </>
  );
};

export default About;

const StyledPropertyInfoWrapper = styled.div`
  width: 100%;
`;

const StyledFlexDiv = styled.div<{ $md: boolean }>`
  display: flex;
  flex-direction: ${({ $md }) => ($md ? 'row' : 'column')};
  justify-content: space-between;
  width: 100%;
`;

const StyledDetailsWrapper = styled.div<{ $md: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ $md }) => ($md ? 'row' : 'column')};
  width: 100%;
  * {
    width: 50%;
  }
  > div {
    padding: ${({ $md }) => ($md ? '20px' : '')};
  }
  table,
  th,
  td {
    border-top: 1px solid ${theme.gray5};
    padding: 3px;
  }
`;
